import axios from 'axios';

export const amperageApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/amperage`,
    headers: {
        'Content-Type': 'application/json'
    }
})